import { render } from "./WaybillsItem.vue?vue&type=template&id=87486f1a"
import script from "./WaybillsItem.vue?vue&type=script&lang=js"
export * from "./WaybillsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__